<panel>
	<h1>{{ (registerNewDomain ? 'company.domains.register-new.header' : 'company.domains.add-existing.header') | translate }}</h1>
	<h3>{{ (registerNewDomain ? 'company.domains.lookup-header.new-domain' : 'company.domains.lookup-header.existing-domain') | translate }}</h3>
	<lookup-domain (onLookup)="nameServerResponse = $event" (busyChange)="lookupBusy = $event" [buttonLabel]="(registerNewDomain ? 'company.domains.lookup-button.new-domain' : 'company.domains.lookup-button.existing-domain') | translate" />
	@if (loading()) {
		<section>
			<skeletons [defaultSkeletons]="3" />
		</section>
	}
	@else
	{
		@if (registerNewDomain && nameServerResponse) {
			<list-view [selectable]="false" emptyLabel="">
				@if (domainIsAvailable) {
					<list-item success statusIcon="square-check">{{ 'company.domains.domain-vacant' | translate }}</list-item>
				}
				@if (!domainIsAvailable) {
					<list-item warning statusIcon="exclamation-triangle">{{ 'company.domains.domain-not-vacant' | translate }}</list-item>
				}
			</list-view>
			@if (domainIsAvailable) {
				<section>
					<button [ignoreValidation]="true" confirm (click)="buyDomain()" [disabled]="!productPlan"><icon type="shopping-cart" />{{ 'company.domains.begin-domain-registration' | translate }}</button>
				</section>
			}
		}
		@if (!registerNewDomain) {
			<list-view [selectable]="false" emptyLabel="">
				@if (nameServerResponse && domainIsAvailable) { <list-item alert statusIcon="exclamation-triangle">{{ 'company.domains.lookup-result.domain-is-available' | translate }}</list-item> }
				@if (sameCompanyAlreadyHasDomain) { <list-item alert statusIcon="exclamation-triangle">{{ 'company.domains.lookup-result.company-already-has-domain' | translate }}</list-item> }
				@else if (anyCompanyAlreadyHasDomain) { <list-item alert statusIcon="exclamation-triangle">{{ 'company.domains.lookup-result.another-company-already-has-domain' | translate }}</list-item> }
			</list-view>
			@if (nameServerResponse && !domainIsAvailable && !sameCompanyAlreadyHasDomain && !anyCompanyAlreadyHasDomain) {
				<h3>{{ 'company.domains.name-server-response' | translate }}</h3>
				<domain-dns-details [dnsResult]="nameServerResponse" />
				<section>
					<custom-select [label]="'company.domains.add-with-dns-label' | translate" [selectList]="dnsOptions" [(value)]="domainAction" [required]="true"></custom-select>
				</section>
				<section>
					<button (click)="addDomain()" [active]="anyCompanyAlreadyHasDomain !== undefined"><icon type="plus" /> {{ 'company.domains.add-domain' | translate }}</button>
				</section>
			}
		}
	}
</panel>
